import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { COMPANY, TRAVEL_QUOTES } from "../data/site";

export const LoadingScreen = ({ onDone, duration = 2200 }) => {
  const [quote] = useState(() => TRAVEL_QUOTES[Math.floor(Math.random() * TRAVEL_QUOTES.length)]);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => { setGone(true); onDone?.(); }, duration);
    return () => clearTimeout(t);
  }, [duration, onDone]);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          data-testid="loading-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
          className="fixed inset-0 z-[100] bg-[#0A221C] flex flex-col items-center justify-center px-8"
        >
          <div className="grain" />
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="relative flex flex-col items-center text-center"
          >
            <span className="bg-white rounded-2xl px-5 py-3 shadow-2xl">
              <img src={COMPANY.logo} alt="Life Line Tours and Travels" className="h-14 w-auto object-contain" />
            </span>

            {/* Animated route line */}
            <div className="mt-10 w-56 h-[3px] bg-white/15 rounded-full overflow-hidden">
              <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: "100%" }}
                transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
                className="h-full w-1/2 bg-[#4ef72d] rounded-full"
              />
            </div>

            <motion.p
              key={quote}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="font-display italic text-white/85 text-lg md:text-xl mt-8 max-w-md"
            >
              {quote}
            </motion.p>
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#4ef72d] font-semibold mt-4">Creating Memories Since 1991</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
